import { commentsData } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
            吃瓜群众
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">瓜友热评</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">千万吃瓜群众的真实声音，看看大家怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{item.name}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {item.content}
                  </p>
                  <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
                    <i className="ri-thumb-up-line"></i>
                    <span>{item.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}